export function trimToWindow(dataArr, windowStartMs) {
  return dataArr.filter((d) => d.date >= windowStartMs);
}

export function recomputeMinMax(dataArr, valueKey) {
  let minValue = Number.POSITIVE_INFINITY;
  let maxValue = Number.NEGATIVE_INFINITY;
  for (const d of dataArr) {
    const v = d[valueKey];
    if (v < minValue) minValue = v;
    if (v > maxValue) maxValue = v;
  }
  return { minValue, maxValue };
}
